module.exports = __webpack_public_path__ + "static/villain-7e3d1c2b7a4912336245d624fd04614e.jpg";